<template>
  <v-dialog
    :value="enableDialog"
    persistent
    width="1200"
    @keydown.esc="closeButtonClickEvent"
    @close="closeButtonClickEvent"
  >
    <v-card flat>
      <v-toolbar flat>
        <v-toolbar-title>受注から検索</v-toolbar-title>
      </v-toolbar>
      <v-divider />
      <v-card-text>
        <v-row class="pt-2">
          <v-col cols="12" md="4">
            <v-row>
              <v-col cols="12" md="6">
                <cs-date-picker
                  :date.sync="searchForms.carryInStartDate"
                  @dateChangedCallback="carryInStartDateChangedCallback"
                >
                  <template v-slot="{ on, attrs }">
                    <v-text-field
                      v-model="searchForms.carryInStartDate"
                      v-bind="attrs"
                      v-on="on"
                      append-icon="mdi-calendar"
                      clearable
                      dense
                      hide-details="auto"
                      label="搬入日（From）"
                      outlined
                      persistent-placeholder
                      placeholder="日付を選択"
                      readonly
                      rounded
                      style="font-size: 80%"
                       @click:clear="searchForms.carryInStartDate = null"
                    >
                      <template v-slot:append-outer>
                        <div
                          v-if="$vuetify.breakpoint.mdAndUp"
                          style="vertical-align: middle"
                        >
                          〜
                        </div>
                      </template>
                    </v-text-field>
                  </template>
                </cs-date-picker>
              </v-col>
              <v-col cols="12" md="6">
                <cs-date-picker
                  :date.sync="searchForms.carryInEndDate"
                  @dateChangedCallback="carryInEndDateChangedCallback"
                >
                  <template v-slot="{ on, attrs }">
                    <v-text-field
                      v-model="searchForms.carryInEndDate"
                      v-bind="attrs"
                      v-on="on"
                      append-icon="mdi-calendar"
                      clearable
                      dense
                      hide-details="auto"
                      label="搬入日（To）"
                      outlined
                      persistent-placeholder
                      placeholder="日付を選択"
                      readonly
                      rounded
                      style="font-size: 80%"
                      @click:clear="searchForms.carryInEndDate = null"
                    />
                  </template>
                </cs-date-picker>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" md="4">
            <v-row>
              <v-col cols="12" md="6">
                <cs-date-picker
                  :date.sync="searchForms.pickupStartDate"
                  @dateChangedCallback="pickupStartDateChangedCallback"
                >
                  <template v-slot="{ on, attrs }">
                    <v-text-field
                      v-model="searchForms.pickupStartDate"
                      v-bind="attrs"
                      v-on="on"
                      append-icon="mdi-calendar"
                      clearable
                      dense
                      hide-details="auto"
                      label="引取日（From）"
                      outlined
                      persistent-placeholder
                      placeholder="日付を選択"
                      readonly
                      rounded
                      style="font-size: 80%"
                      @click:clear="searchForms.pickupStartDate = null"
                    >
                      <template v-slot:append-outer>
                        <div
                          v-if="$vuetify.breakpoint.mdAndUp"
                          style="vertical-align: middle"
                        >
                          〜
                        </div>
                      </template>
                    </v-text-field>
                  </template>
                </cs-date-picker>
              </v-col>
              <v-col cols="12" md="6">
                <cs-date-picker
                  :date.sync="searchForms.pickupEndDate"
                  @dateChangedCallback="pickupEndDateChangedCallback"
                >
                  <template v-slot="{ on, attrs }">
                    <v-text-field
                      v-model="searchForms.pickupEndDate"
                      v-bind="attrs"
                      v-on="on"
                      append-icon="mdi-calendar"
                      clearable
                      dense
                      hide-details="auto"
                      label="引取日（To）"
                      outlined
                      persistent-placeholder
                      placeholder="日付を選択"
                      readonly
                      rounded
                      style="font-size: 80%"
                      @click:clear="searchForms.pickupEndDate = null"
                    />
                  </template>
                </cs-date-picker>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="2">
            <v-text-field
              v-model="searchForms.orderNumber"
              background-color="white"
              dense
              hide-details="auto"
              label="受注番号"
              outlined
              rounded
              persistent-placeholder
              clearable
              style="font-size: 80%"
            />
          </v-col>

          <v-col cols="12" md="2">
            <v-select
              v-model="searchForms.requestNumberFlag"
              :items="requestNumberFlags"
              dense
              hide-details="auto"
              label="依頼番号有無"
              clearable
              outlined
              persistent-placeholder
              rounded
              style="font-size: 80%"
            />
          </v-col>

          <v-col cols="12" md="2">
            <v-text-field
              v-model="searchForms.requestNumber"
              clearable
              dense
              hide-details="auto"
              label="依頼番号"
              outlined
              persistent-placeholder
              rounded
              style="font-size: 80%"
            />
          </v-col>

          <v-col
            v-if="isBilling"
            cols="12" md="2"
          >
            <v-select
              v-model="searchForms.dealNumberFlag"
              :items="dealNumberFlags"
              clearable
              dense
              hide-details="auto"
              label="取引番号有無"
              outlined
              persistent-placeholder
              rounded
              style="font-size: 80%"
            />
          </v-col>
          <v-col
            v-if="isBilling"
            cols="12" md="2"
          >
            <v-text-field
              v-model="searchForms.dealNumber"
              clearable
              background-color="white"
              dense
              hide-details="auto"
              label="取引番号"
              outlined
              persistent-placeholder
              rounded
              style="font-size: 80%"
            />
          </v-col>
        </v-row>
        <v-row>
        <v-col cols="12" md="2">
          <v-text-field
            v-model="searchForms.keyword"
            clearable
            dense
            hide-details="auto"
            label="運搬先"
            outlined
            placeholder="運搬先を検索"
            persistent-placeholder
            rounded
            style="font-size: 80%"
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="searchForms.searchKeyword"
            dense
            hide-details="auto"
            label="検索キーワード"
            outlined
            rounded
            persistent-placeholder
            clearable
            style="font-size: 80%"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          @click="searchButtonClickEvent"
        >
          <v-icon>mdi-magnify</v-icon>&nbsp;検索
        </v-btn>
      </v-card-actions>
      <v-divider />
      <v-card-text
        style="padding: 0 5px 20px;"
      >
        <v-data-table
          :headers="isBilling ? billingTableHeaders : tableHeaders"
          :items="orders"
          :items-per-page="-1"
          disable-sort
          hide-default-footer
          fixed-header
          dense
          height="35vh"
          single-select
          @click:row="rowClickEvent"
          @dblclick:row="rowDoubleClickEvent"
        >
          <!-- ステータス -->
          <template v-slot:[`item.status`]="{ item }">
            <v-chip
              x-small
              label
              :color="item.status | status_chip_order_color"
            >
              {{ item.status | simple_status_to_label_order }}
            </v-chip>
          </template>
          <!-- ステータス -->
          <!-- オーダー番号/受注日 -->
          <template v-slot:[`item.order_no`]="{ item }">
            <div>
              {{ item.order_no }}&nbsp;
            </div>
            <small class="text--disabled">{{ item.order_date | date_format }}</small>
          </template>
          <!-- /オーダー番号/受注日 -->
          <!-- 依頼番号/依頼日 -->
          <template v-slot:[`item.request_no`]="{ item }">
            <div>{{ item.request_no }}&nbsp;</div>
            <span v-if="item.request_no">
              <small class="text--disabled">
                {{ item.created_at | unix_date_format }}
              </small>
            </span>
          </template>
          <!-- 依頼番号/依頼日 -->

          <!-- 回収/搬入/引取日 -->
          <template v-slot:[`item.target_date`]="{ item }">
            <small>{{ item.target_date | date_format }}</small>
          </template>
          <!-- /回収日 -->

          <!-- 排出事業者 -->
          <template v-slot:[`item.supplier`]="{ item }">
            <div>
                {{ item.supplier.name | truncate(10) }}
                <v-tooltip top :open-on-hover="false">
                  <template #activator="{ on }">
                    <v-btn
                      icon
                      tile
                      small
                      retain-focus-on-click
                      @click="on.click"
                      @blur="on.blur"
                    >
                      <v-icon small>mdi-map-marker-outline</v-icon>
                    </v-btn>
                  </template>
                  <div>
                    <strong>{{ item.supplier.name }}</strong>
                    <br />
                    <small>{{ item.supplier.address }}</small>
                  </div>
                </v-tooltip>
              </div>
              <div>
                {{ item.supplier_location.name | truncate(10) }}
                <v-tooltip top :open-on-hover="false">
                  <template #activator="{ on }">
                    <v-btn
                      v-if="item.supplier_location.name"
                      icon
                      tile
                      small
                      retain-focus-on-click
                      @click="on.click"
                      @blur="on.blur"
                    >
                      <v-icon small>mdi-map-marker-outline</v-icon>
                    </v-btn>
                  </template>
                  <div>
                    <strong>{{ item.supplier_location.name }}</strong>
                    <br />
                    <small>{{ item.supplier_location.address }}</small>
                  </div>
                </v-tooltip>
              </div>
          </template>
          <!-- /排出事業者 -->
          <!-- 運搬先 -->
          <template v-slot:[`item.destination_location`]="{ item }">
            <div>
              {{ item.destination_location.name | truncate(10) }}
            </div>
            <small
              ><span v-if="item.total_traders_count > 0"
                >&emsp;全&nbsp;{{ item.total_traders_count }}件</span
              ></small
            >
          </template>
          <!-- /運搬先 -->
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-row dense>
          <v-col>
            <v-pagination
              v-model="page"
              :length="pagination.total_pages"
              :total-visible="totalVisible"
              circle
              prev-icon="mdi-menu-left"
              next-icon="mdi-menu-right"
              @input="pageChangeEvent"
            />
          </v-col>
        </v-row>
      </v-card-actions>
      <v-divider />
      <v-card-actions>
        <v-btn
          :disabled="!this.targetOrderNo"
          color="error"
          @click="deleteButtonClickEvent"
        >
          削除
        </v-btn>
        <v-spacer />
        <v-btn
          @click="closeButtonClickEvent"
        >
          閉じる
        </v-btn>
        <v-btn
          :disabled="!selectedItem"
          class="primary"
          @click="registerButtonClickEvent"
        >
          登録
        </v-btn>
      </v-card-actions>
    </v-card>
    <confirm ref="confirm" />
  </v-dialog>
</template>

<script>
import {mapActions, mapState} from "vuex";
import Confirm from '../../../../../components/Confirm'

export default {
  name: 'EditOrderNumberDialog',
  components: {
    Confirm
  },
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
    targetManifestId: {
      type: Number,
      default: () => null,
    },
    targetOrderNo: {
      type: Number,
      default: () => null,
    },
  },
  data() {
    return {
      panel: [],
      page: 1,
      totalVisible: 7,
      selectedItem: null,
      selectedRow: null,
      searchForms: {
        keyword: null,
        collectedDateType: null,
      },
      billingTableHeaders: [
        { text: 'ステータス', value: 'status' },
        { text: '受注番号\r\n受注日', value: 'order_no', align: 'center' },
        { text: '依頼番号\r\n依頼日', value: 'request_no', align: 'center' },
        { text: '積替・搬入日 ', value: 'target_date', align: 'center' },
        { text: '取引先（事業者）\r\n取引先（事業場）', value: 'supplier' },
        { text: '運搬先事業場', value: 'destination_location' },
        { text: '取引番号', value: 'deal_no' },
      ],
      tableHeaders: [
        { text: 'ステータス', value: 'status' },
        { text: '受注番号\r\n受注日', value: 'order_no', align: 'center' },
        { text: '依頼番号\r\n依頼日', value: 'request_no', align: 'center' },
        { text: '積替・搬入日 ', value: 'target_date', align: 'center' },
        { text: '取引先（事業者）', value: 'supplier' },
        { text: '運搬先事業場', value: 'destination_location' },
      ],
      /** 依頼番号有無 */
      requestNumberFlags: [
        { value: 'something', text: '有'},
        { value: 'nothing', text: '無' }
      ],
      /** 取引番号有無 */
      dealNumberFlags: [
        { value: 'something', text: '有'},
        { value: 'nothing', text: '無' },
        { value: 'not_sales', text: '計上しない' }
      ],
      orders: [],
      locations: [],
      pagination: {
        current_page: 1,
        total_count: 0
      },
      /** ドライバー */
      drivers: [],
      emissions: [],
    }
  },
  computed: {
    ...mapState('DriverTenantConfiguration', {
      isBilling: 'use_billing',
    }),
  },
  watch: {
    enableDialog () {
      this.panel = []
      this.orders = []
      this.page = 1
      this.pagination = {current_page: 1,total_count: 0}
      if (this.selectedRow) {
        this.selectedRow.select(false)
      }
      this.selectedItem = null

    },
  },
  created() {
    this.fetchDrivers().then((content) => {
      this.drivers = content.drivers
    })
  },
  methods: {
    ...mapActions('DriverOrderSearchAccept', {
      fetchOrders: 'index'
    }),
    ...mapActions('DriverMasterSearchDriver', {
      fetchDrivers: 'index'
    }),
    /**
     * 行選択イベント
     * @param item 
     * @param row 
     */
    rowClickEvent (item, row) {
      this.selectedItem = item
      this.selectedRow = row
      row.select(true)
    },
    /**
     * 行反映ダブルクリックイベント
     */
    rowDoubleClickEvent($event, row) {
      this.$emit("registerCallback", row.item); 
    },
    pageChangeEvent () {
      this.searchOrders()
    },
    /**
     * 搬入日 (from)変更　コールバック
     */
    carryInStartDateChangedCallback (value) {
      this.searchForms.carryInStartDate = value;
    },
    /**
     * 搬入日 (to)変更　コールバック
     */
    carryInEndDateChangedCallback (value) {
      this.searchForms.carryInEndDate = value;
    },
    /**
     * 引取日 (from)変更　コールバック
     */
    pickupStartDateChangedCallback (value) {
      this.searchForms.pickupStartDate = value;
    },
    /**
     * 引取日 (to)変更　コールバック
     */
    pickupEndDateChangedCallback (value) {
      this.searchForms.pickupEndDate = value;
    },
    searchButtonClickEvent () {
      this.page = 1
      this.searchOrders()
    },
    searchOrders () {
      let params = this.buildParam('json')
      this.fetchOrders({params: params}).then((content) => {
        this.orders = content.orders
        this.pagination = content.pagination
      })
    },
    buildParam (format) {
      return {
        page: this.page,
        manifest_id: this.targetManifestId,
        carry_in_start_date: this.searchForms.carryInStartDate,
        carry_in_end_date: this.searchForms.carryInEndDate,
        pickup_start_date: this.searchForms.pickupStartDate,
        pickup_end_date: this.searchForms.pickupEndDate,
        order_number: this.searchForms.orderNumber,
        request_number_flag: this.searchForms.requestNumberFlag,
        request_number: this.searchForms.requestNumber,
        deal_number_flag: this.searchForms.dealNumberFlag,
        deal_number: this.searchForms.dealNumber,
        keyword: this.searchForms.keyword,
        search_keyword: this.searchForms.searchKeyword,
        only_have_order_no: true,
        format: format,
      }
    },

    closeButtonClickEvent () {
      this.$emit('closeCallback')
    },
    registerButtonClickEvent () {
      this.$emit('registerCallback', this.selectedItem)
    },
    deleteButtonClickEvent () {
      let modalOption = { title: '削除', message: '削除します。よろしいですか？', options: { titleColor: 'red', cancelTitle: 'いいえ', successTitle: 'はい' } }
      this.$refs.confirm.open(modalOption).then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.$emit('deleteCallback')
        }
      })
    },
  }
}
</script>

<style scoped lang="scss">

</style>
